
  Vue.component('highlighted-text', {
    props: {
      highlights: { type: Array }
    },
    data() {
      return {}
    },
    template: '#highlighted-text',
    computed: {
      hlText() {
        let fullText = ''
        if (this.$slots.default) {
          this.$slots.default.forEach(slot => {
            fullText += this.navigateSlotTree(slot)
          })
        }
        return fullText
      }
    },
    watch: {},
    methods: {
      navigateSlotTree(slot) {
        let fullText = ''
        if (slot.text) {
          fullText += this.replaceHighlights(slot.text)
        } else if (slot.children) {
          fullText += `<${slot.tag}>`
          slot.children.forEach(child => {
            fullText += this.navigateSlotTree(child)
          })
          fullText += `</ ${slot.tag}>`
        } else if (slot.tag) {
          fullText += `<${slot.tag} />`
        }
        return fullText
      },
      replaceHighlights(html) {
        let fullText = html
        const boldContents = []
        const regex = /<b>(.*?)<\/b>/gi
        this.highlights.forEach(item => {
          let match
          while ((match = regex.exec(item)) !== null) {
            boldContents.push(match[1])
          }
        })
        boldContents.forEach(content => {
          const regexb = new RegExp(content, 'gi')
          const regexc = new RegExp(`<b>${content}</b>`, 'gi')
          fullText = fullText.replace(regexc, content)
          fullText = fullText.replace(regexb, `<b>${content}</b>`)
        })
        return fullText
      }
    },
    mounted() {}
  })
